import { ref } from "vue"
import { useWindowEvents } from "./useWindowEvents";

type Interval = ReturnType<typeof setInterval>;

export const useMouseInActivity = (props: {
  thresholdSeconds: number,
  callback: (rewind: () => void) => void | Promise<void>,
}) => {
  const interval = ref<Interval | null>(null);
  const lastTime = ref<number>(performance.now());
  const fired = ref<boolean>(false);
  const windowEvents = useWindowEvents();

  const rewind = () => {
    lastTime.value = performance.now();
    fired.value = false;
  }

  const onActivity = () => {
    if (!fired.value) {
      lastTime.value = performance.now();
    }
  }

  const events: (keyof WindowEventMap)[] = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
  for (const event of events) {
    windowEvents.addEventListener(event, onActivity);
  }

  interval.value = setInterval(() => {
    const now = performance.now();
    const elapsed = (now - lastTime.value) / 1000;

    if (elapsed >= props.thresholdSeconds && !fired.value) {
      fired.value = true;
      props.callback(rewind);
    }
  }, 1000);

  return { rewind };
}
